module.exports = __webpack_public_path__ + "img/Frame 715.ee1e7700.png";